import { z } from 'zod';
import { listSearchSchema } from '@/shared/patterns/list-search';
import { userFilters } from './user.filters';
/** Tamanhos da lista do legado (`UsersList.tsx:158`). */
export const USER_PAGE_SIZES = [5, 10, 15, 20, 60] as const;
export const USER_TABS = ['informacoes', 'grupos', 'permissoes'] as const;
export const userListSearch = listSearchSchema(
  { ...userFilters.shape, paginationToken: z.string().optional().catch(undefined) },
  { sizes: USER_PAGE_SIZES },
);
export const userDetailSearch = z.object({
  tab: z.enum(USER_TABS).optional().catch(undefined),
  sheet: z.string().optional().catch(undefined),
  /** Depois de criar o operador: o painel "Próximos passos" (S07). */
  proximos: z.boolean().optional().catch(undefined),
});
